export enum SelectLocationConfiguration {
  AddLocation = 'AddLocation',
  SetProximityToolStartLocation = 'SetProximityToolStartLocation',
  SetPlacesToolStartLocation = 'SetPlacesToolStartLocation',
  ZoomToLocation = 'ZoomToLocation',
}

export type SelectLocationState = Readonly<{
  active: boolean;
  isAddressLookupLoading?: boolean;
  configuration?: SelectLocationConfiguration;
  extras: Readonly<{
    value?: number;
  }>;
}>;
